import * as React from 'react'
import { useQuery } from 'react-query'
import { IOption, IProviderProps } from '@user/components/Filters'
import { get } from '@user/store/services/crud'
import { ServiceConfig } from '@user/store/services/config'

export const ServiceProvider: React.FC<IProviderProps> = ({ render }) => {
  const { data, isFetching } = useQuery(
    ['filters', 'opp', 'service'],
    async (): Promise<IOption[]> => {
      const result = await get(
        `${ServiceConfig.baseAPIUrl}${ServiceConfig.filters(
          'opportunities',
          'Services',
        )}`,
      )

      const services: { id: string; name: string }[] = await result.json()
      const options: IOption[] = services.map(({ id, name }) => ({
        label: name,
        value: id,
      }))
      return options
    },
  )

  return <>{render(data ?? [], isFetching)}</>
}
ServiceProvider.displayName = 'ServiceProvider'
